export default class extends HTMLElement {
  connectedCallback () {
    this.emailInput = this.querySelector('[data-copy-email]')
    this.phoneInput = this.querySelector('[data-copy-phone]')
    this.smsConsentInput = this.querySelector('[data-copy-sms-consent]')
    this.smsConsentWrapper = this.querySelector('[data-copy-sms-consent-wrapper]')
    this.forceEmail = this.emailInput?.required === true
    this.forcePhone = this.phoneInput?.required === true

    if (!this.emailInput) return

    this.updateRequirements = this.updateRequirements.bind(this)
    this.emailInput.addEventListener('input', this.updateRequirements)
    this.phoneInput?.addEventListener('input', this.updateRequirements)
    this.updateRequirements()
  }

  disconnectedCallback () {
    this.emailInput?.removeEventListener('input', this.updateRequirements)
    this.phoneInput?.removeEventListener('input', this.updateRequirements)
  }

  updateRequirements () {
    const hasEmail = this.emailInput.value.trim().length > 0
    const hasPhone = this.phoneInput?.value.trim().length > 0

    this.emailInput.required = this.forceEmail || !hasPhone

    if (this.phoneInput) {
      this.phoneInput.required = this.forcePhone || (!hasEmail && !this.forceEmail)
    }

    if (this.smsConsentInput) {
      this.smsConsentInput.required = hasPhone
      if (!hasPhone) this.smsConsentInput.checked = false
      this.smsConsentWrapper.classList.toggle('hidden', !hasPhone)
      this.smsConsentWrapper.classList.toggle('flex', hasPhone)
    }
  }
}
